import React from 'react';

import CPCRebateWinter  from 'components/Tvendo/Sale/QuotaBPartner/Winter/CuotaRebate/List';

export default function () {
  return <CPCRebateWinter  />;
}